import React from "react";
import { Table } from "../../../../packages/ui/table/Table.js";
import { useVatReport } from "./VatReportProvider.js";
import { VatReportField1 } from "./VatReportField1.js";
import { VatReportField3 } from "./VatReportField3.js";
import { VatReportField4 } from "./VatReportField4.js";
import { VatReportField5 } from "./VatReportField5.js";
import { VatReportField6 } from "./VatReportField6.js";
import { VatReportField12 } from "./VatReportField12.js";
import { VatReportField13 } from "./VatReportField13.js";

/**
 * Renders the monthly VAT report table.
 */
export const VatReportTable = () => {
  const { report } = useVatReport();

  if (!report) {
    return null;
  }

  return (
    <Table fontSize="tiny" fullWidth={true} tableLayout="fixed">
      <tbody>
        <VatReportField1 vatBaseTaxedAmount={report.vatBaseTaxedAmount} />
        <VatReportField3
          services={report.vatZeroTaxedAmount.services}
          servicesItems={report.vatZeroTaxedAmount.servicesItems}
        />
        <VatReportField4 vatTotal={report.vatTotal} />
        <VatReportField5 vatReturn={report.vatReturn} />
        <VatReportField6 expensesEu={report.expensesEu} expensesEuItems={report.expensesEuItems} />
        <VatReportField12 vatExpense={report.vatExpense} />
        <VatReportField13 vatIncome={report.vatIncome} />
      </tbody>
    </Table>
  );
};
